// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8512) return "css/8512-2c40824b.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"3095":"5ffb66e7","7701":"8aea31ff"}[chunkId] + ".css";
};